import initSimilarRecommendedListingsModule from './similarRecommendedListings'
import initSimilarToSoldListingsModule from './similarToSoldListings'
import initViewMoreListingsModules from './viewMoreListings'
import initSimilarQueryModules from './similarQueryModules'
import initCrossCategoryModules from './crossCategoryModules'
import { initCompleteTheRoomSection } from '../homepageListingCarousels'
import { initLazyLoadedImages } from '../listing_tile_rendering/listingImageRenderer'
import { setOpenModalButtons } from '../modals'
import setUpAddToWishlistBehaviour from '../addToWishlist'

export default function initRelatedListingsModules () {
  initSimilarToSoldListingsModule()

  initCrossCategoryModules()

  initSimilarRecommendedListingsModule()

  initCompleteTheRoomSection().then(() => {
    initLazyLoadedImages()
    setOpenModalButtons()
    setUpAddToWishlistBehaviour()
  })

  initSimilarQueryModules()

  initViewMoreListingsModules()
}
